export enum DefaultFinancialLogMutationReasons {
    doubledProcess = 'doubledProcess',
    incorrectSettings = 'incorrectSettings',
    other = 'other',
    test = 'test',
}
